import { Banner, Breadcrumbs, Content, Navigation, Portalizer } from '../components';
import { useConfiguration } from '../contexts';

export const OnlineTopBanner = () => {
  const { bannerSelector, breadcrumbsSelector, isPortalMode, submenuSelector, contentSelector } = useConfiguration();
  if (isPortalMode) {
    return (
      <>
        {breadcrumbsSelector ? (
          <Portalizer selector={breadcrumbsSelector}>
            <Breadcrumbs />
          </Portalizer>
        ) : null}
        {bannerSelector ? (
          <Portalizer selector={bannerSelector}>
            <Banner
              isPortalMode
              hasNoBreadcrumbs={Boolean(breadcrumbsSelector)}
            />
          </Portalizer>
        ) : null}
        {submenuSelector ? (
          <Portalizer selector={submenuSelector}>
            <Navigation />
          </Portalizer>
        ) : null}
        {contentSelector ? (
          <Portalizer selector={contentSelector}>
            <Content />
          </Portalizer>
        ) : null}
      </>
    );
  }

  return (
    <>
      <Banner />
      <Navigation />
      <Content />
    </>
  );
};
